import {
  RESET_CLAIMS_DATATABLE,
  SET_CURRENT_CLAIMS_PAGE,
  SET_NUMBER_OF_CLAIMS_TO_SHOW_PER_PAGE
} from '../../../../constants';

const initialState = {
  currentPage: 0,
  numOfRecordsPerPage: 25
};

export const renewalClaimDataTableReducer = (
  state = initialState,
  { type, currentPage, numOfRecordsPerPage }
) => {
  switch (type) {
    case RESET_CLAIMS_DATATABLE:
      return {
        ...initialState
      };

    case SET_CURRENT_CLAIMS_PAGE:
      return {
        ...state,
        ...{
          currentPage
        }
      };

    case SET_NUMBER_OF_CLAIMS_TO_SHOW_PER_PAGE:
      return {
        ...state,
        ...{
          numOfRecordsPerPage
        }
      };

    default:
      return state;
  }
};

export default renewalClaimDataTableReducer;
